import classNames from 'classnames';
import { IconArrowUp } from 'featherico';
import { Component } from 'react';
import { scrollToAnimated } from '../../services/Scroll';
import Button from '../Button';
import styles from './style.m.less';

const HEADER_OFFSET = 50;

export default class ToTopButton extends Component {
    render() {
        const { top, show, offset, onClick } = this.props;
        const classes = classNames(styles.button, { [styles.visible]: show });

        const onToTop = event => {
            const yPosition = (top || 0) - offset - HEADER_OFFSET;
            scrollToAnimated(window.pageXOffset, yPosition, 0);
            onClick(event);
        };

        return (
            <Button kind="PLAIN" className={classes} onClick={onToTop}>
                <IconArrowUp /> To Top
            </Button>
        );
    }
}

ToTopButton.defaultProps = {
    onClick: () => {},
    offset: 0,
};
